import { Component, Input, NgModule } from '@angular/core';
import { DataCardInterface } from '../../utils/models/data-card-interface';
import { FormatDataValuePipe, FormatDataValuePipeModule } from '../../../pipes/format-data-value.pipe';
import { CommonModule } from '@angular/common';
import { NgIconsModule } from '@ng-icons/core';
import { heroBanknotes, heroBriefcase, heroCreditCard, heroWallet } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-data-information-card',
  templateUrl: './data-information-card.component.html',
  styleUrl: './data-information-card.component.scss'
})
export class DataInformationCardComponent {
  @Input() titleText!: string;

  @Input() data: DataCardInterface | null = null;

  @Input() icon!: string;

  @Input() tone?: 'warning' | 'info';

  @Input() contentClass: string | null = null;
}

@NgModule({
  imports: [
    FormatDataValuePipeModule,
    CommonModule,
    NgIconsModule.withIcons({  
      heroWallet,
      heroBanknotes,
      heroBriefcase,
      heroCreditCard
    })
  ],
  declarations: [DataInformationCardComponent],
  exports: [DataInformationCardComponent],
})
export class DataInformationCardModule { }
